import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts';
import MessageContainer from './MessageContainer';

const RedirectDisplay: FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 4500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <MessageContainer>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">{t("promptPrivate")}</h2>
      <p className="text-gray-600 mb-4">{t("promptPrivateDescription")}</p>
    </MessageContainer>
  );
};

export default RedirectDisplay;
